module.exports = __webpack_public_path__ + "img/no_data_bg.0b821618.png";